import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

export function LoadingSpin() {
  const componentColors = useSelector(
    (state: RootState) => state.theme.componentColors
  );

  return (
    <div className="w-full flex items-center justify-center">
      <div
        style={{
          borderTop: "4px solid",
          borderTopColor: componentColors.primary.primary,
        }}
        className="w-10 h-10 rounded-full animate-spin"
      />
    </div>
  );
}
